import {
  SET_RESETMINED_TAB,
  SET_RESETLAB_TAB,
  SET_RESETFANCY_TAB,
  SET_RESETREQUEST_TAB,
  SET_COMPARE_TAB_IDS,
  SET_DIAMOND_DETAILS,
  SET_SAVESEARCH_MINEDTAB,
  SET_SAVEFILTER_MINEDTAB,
  SET_SAVEEVERYTIME_MINEDTAB,
  SET_SWITCHFILTER_MINEDTAB,
  SET_SAVESEARCH_LABTAB,
  SET_SAVEFILTER_LABTAB,
  SET_SAVEEVERYTIME_LABTAB,
  SET_SWITCHFILTER_LABTAB,
  SET_SAVESEARCH_FANCYTAB,
  SET_SAVEFILTER_FANCYTAB,
  SET_SAVEEVERYTIME_FANCYTAB,
  SET_SWITCHFILTER_FANCYTAB,
  SET_COMPARE_PAGE_KEY,
  SET_RESETMINED_TOGGLE,
  SET_RESETLAB_TOGGLE,
  SET_RESETFANCY_TOGGLE,
} from "../../actions/selectyourdiamond/types";

const initialState = {
  resetMined: true,
  resetMinedToogle: true,
  resetLab: true,
  resetlabToogle: true,
  resetFancy: true,
  resetFancyToogle: true,
  resetRequest: true,

  saveSearchMined: false,
  minedDiamondFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Certificate: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeMined: {},
  saveSearchLab: false,
  LabDiamondFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Certificate: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeLab: {},

  saveSearchFancy: false,
  FancyDiamondFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Intensity: [],
    Certificates: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeFancy: {},
  compareIds: [],
  compareKey: "",
  diamondDetails: {},
};

export default function handleHeader(
  SelectYourDiamondState = initialState,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case SET_RESETMINED_TAB:
      return {
        ...SelectYourDiamondState,
        resetMined: payload,
      };
    case SET_RESETMINED_TOGGLE:
      return {
        ...SelectYourDiamondState,
        resetMinedToogle: !SelectYourDiamondState.resetMinedToogle,
      };

    case SET_RESETLAB_TAB:
      return {
        ...SelectYourDiamondState,
        resetLab: payload,
      };
    case SET_RESETLAB_TOGGLE:
      return {
        ...SelectYourDiamondState,
        resetlabToogle: !SelectYourDiamondState.resetlabToogle,
      };
    case SET_RESETFANCY_TAB:
      return {
        ...SelectYourDiamondState,
        resetFancy: payload,
      };
    case SET_RESETFANCY_TOGGLE:
      return {
        ...SelectYourDiamondState,
        resetFancyToogle: !SelectYourDiamondState.resetFancyToogle,
      };
    case SET_RESETREQUEST_TAB:
      return {
        ...SelectYourDiamondState,
        resetRequest: !SelectYourDiamondState.resetRequest,
      };
    case SET_COMPARE_TAB_IDS:
      return {
        ...SelectYourDiamondState,
        compareIds: payload,
      };
    case SET_DIAMOND_DETAILS:
      return {
        ...SelectYourDiamondState,
        diamondDetails: payload,
      };
    case SET_SAVESEARCH_MINEDTAB:
      return {
        ...SelectYourDiamondState,
        saveSearchMined: payload,
      };
    case SET_SAVEFILTER_MINEDTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeMined: payload,
      };

    case SET_SAVEEVERYTIME_MINEDTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeMined: payload,
      };
    case SET_SWITCHFILTER_MINEDTAB:
      return {
        ...SelectYourDiamondState,
        minedDiamondFilter: SelectYourDiamondState.everyTimeFilterChangeMined,
      };

    case SET_SAVESEARCH_LABTAB:
      return {
        ...SelectYourDiamondState,
        saveSearchLab: payload,
      };
    case SET_SAVEFILTER_LABTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeLab: payload,
      };

    case SET_SAVEEVERYTIME_LABTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeLab: payload,
      };
    case SET_SWITCHFILTER_LABTAB:
      return {
        ...SelectYourDiamondState,
        LabDiamondFilter: SelectYourDiamondState.everyTimeFilterChangeLab,
      };

    case SET_SAVESEARCH_FANCYTAB:
      return {
        ...SelectYourDiamondState,
        saveSearchFancy: payload,
      };
    case SET_SAVEFILTER_FANCYTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeFancy: payload,
      };

    case SET_SAVEEVERYTIME_FANCYTAB:
      return {
        ...SelectYourDiamondState,
        everyTimeFilterChangeFancy: payload,
      };
    case SET_SWITCHFILTER_FANCYTAB:
      return {
        ...SelectYourDiamondState,
        FancyDiamondFilter: SelectYourDiamondState.everyTimeFilterChangeFancy,
      };
    case SET_COMPARE_PAGE_KEY:
      return {
        ...SelectYourDiamondState,
        compareKey: payload,
      };

    default:
      return SelectYourDiamondState;
  }
}
